export default {
  "HitPaw Online Audio Joiner": "HitPaw Unir Audio Online",
  "Merge Audio": "Unir audio",
  "Merge multiple audio tracks into one.": "Unir varias pistas de audio en una.",
  "Merge New": "Unir nuevo",
  "Merge failed": "Unir falló",
  "Fade in": "Disolver de entrada",
  "Fade out": "Disolver de salida",
  "Add tracks": "Agregar pistas",
  "Format": "Formato",
};
